import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "../components/ui/sidebar";
import {
  BookOpenWhite,
  CalendarWhite,
  ElementEqualIcon,
  HomeIcon,
  HomeIconFilled,
  UsersIcon,
  FishIcon,
  HeartIcon,
  HelpIcon,
  FavoritesIconFilled,
} from "../components";
import { Skeleton } from "../components/ui/skeleton";
import { useState, useEffect } from "react";
import { NavUser } from "../components/NavUser";
import { ScrollArea } from "../components/ui/scroll-area";
import { Link, useLocation } from "react-router";
import useLiturgicalEvents from "../hooks/useLiturgicalEvents";

const additionalNavItems = [
  {
    title: "Favorites",
    url: "/favorites",
    icon: HeartIcon,
    activeIcon: FavoritesIconFilled,
  },
  { title: "Help", url: "#", icon: HelpIcon },
];

const navUser = {
  name: "Alexandr Berlinsk",
  email: "m@example.com",
  avatar: "",
};

const menuItemClass =
  "px-3 py-2.5 h-auto text-gray-400 data-[active=true]:text-white-50 hover:text-gold-200 data-[active=true]:bg-gray-800 data-[active=true]:hover:text-gray-50 text-sm font-medium leading-4.5 gap-3";


  const getDisciplineIconSrc = (discipline) =>
    `/media/images/discipline_${discipline}.svg`;

export function AppSidebar() {
  const [isLoading, setIsLoading] = useState(true);

  const getCurrentFormattedDate = () => {
    return new Date().toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };
  const today = new Date();

  const { isDataLoading, eventData } = useLiturgicalEvents(
    today.getFullYear(),
    today.getMonth() + 1,
    today.getDate()
  );

  // Extract relevant event details
  const firstEventKey = eventData ? Object.keys(eventData)[0] : null;
  const firstEvent = firstEventKey ? eventData[firstEventKey] : null;
  const disciplines = firstEvent?.disciplines || [];
  useEffect(() => {
    if (!isDataLoading && eventData) {
      setIsLoading(false); //  Hide skeleton only when API data is fully loaded
    }
  }, [isDataLoading, eventData]);

  const daybarData = isLoading
    ? {} //  Show skeleton while loading (NO STATIC DATA)
    : {
        date: firstEvent?.date
          ? new Date(firstEvent.date).toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
              year: "numeric",
            })
          : "",
          title: firstEvent?.name
          ? firstEvent.name.replace(/\s*\/\/\s*/g, "  ")
          : "",
      };

  const location = useLocation();
  const isHome = location.pathname === "/";
  // Menu items.
  const navigationItems = [
    { title: "Home", url: "/", icon: isHome ? HomeIconFilled : HomeIcon },
    { title: "Calendar", url: "/calendar", icon: CalendarWhite },
    {
      title: "Culture & Customs",
      url: "/culture-and-customs",
      icon: ElementEqualIcon,
    },
    { title: "Prayer & Rites", url: "/prayer-and-rites", icon: BookOpenWhite },
    { title: "Learn the Faith", url: "/learn-the-faith", icon: UsersIcon },
  ];

  return (
    <Sidebar className="bg-gray-900">
      <SidebarHeader className="p-3">
        <div className="px-3">
          <div className="pb-3 border-b border-gray-800">
            <img
              src="/media/images/benlogo.svg"
              alt="Benedictus App"
              className="w-[132px] h-[33px]"
            />
          </div>
        </div>
      </SidebarHeader>
      <SidebarContent className="gap-0">
        <ScrollArea>
          <SidebarGroup className="p-3">
            <SidebarGroupContent className="pb-6 border-b border-gray-800">
              <SidebarMenu className="gap-2">
                {navigationItems.map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton
                      asChild
                      isActive={`${location.pathname === item.url ? true : false}`}
                      className={menuItemClass}
                    >
                      <Link to={item.url}>
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
          <SidebarGroup className="p-3">
            <SidebarGroupContent>
              <SidebarMenu className="gap-2">
                {additionalNavItems.map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton
                      asChild
                      isActive={`${location.pathname === item.url ? true : false}`}
                      className={menuItemClass}
                    >
                      <Link to={item.url}>
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        </ScrollArea>
      </SidebarContent>
      <SidebarFooter className="p-3">
        <SidebarMenu>
          <SidebarMenuItem>
            <div className="">
              <div className="flex flex-row items-center justify-between py-1 pl-3 pr-2 mb-6 bg-gray-800 rounded-lg shadow-custom-shadow">
                <div className="flex flex-col">
                  <div className="text-base font-semibold leading-5 text-white-50">
                    {isLoading ? (
                      <Skeleton className="h-5 w-36 rounded-md" />
                    ) : (
                      daybarData.title || "Liturgical Day"
                    )}
                  </div>
                  <p className="mt-1 text-xs font-normal text-gray-400">
                    {getCurrentFormattedDate()}
                  </p>
                </div>
                <div>
                  {/* <FishIcon className="text-gray-800" /> */}
                  {disciplines.map((discipline) => (
                    <img
                      key={discipline}
                      src={getDisciplineIconSrc(discipline)}
                      alt={discipline}
                      className="w-5 h-5"
                    />
                  ))}
                </div>
              </div>
              <NavUser user={navUser} />
            </div>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  );
}
